export const PromptsENG = {
  title: 'Budget Results Dashboard',
  filter1: 'Broad Result',
  filter4: 'Result Category',
  filter2: 'Budget Section',
  filter3: 'Subprogramme',
  filterBeneficiary: 'Beneficiary',
  filterPriority: 'Priority',
  placeholder1: 'Select Broad Result',
  placeholder4: 'Select Result Category',
  placeholder2: 'Select Budget Section',
  placeholder3: 'Select Subprogramme',
  placeholderBeneficiary: 'Beneficiary',
  placeholderPriority: 'Priority',
  resultsCount: ' Result(s) Displayed',
  keyPrompt: 'KEY: ',
  covidPrompt: 'COVID-19-related results are highlighted in yellow',//'COVID-19 related',//'Results above that are COVID-19-related are highlighted in yellow.',
  covidPrompt2: 'COVID-19-related',
  nonCovidPrompt: 'Other',
  source: 'Source: ',
  budgetSection: 'Budget Section ',
  subprogramme: 'Subprogramme',
  appliedFilters: 'Filters',
  memberState: 'Member State',
  budgetSectionFirst: 'Please make sure to select a budget section first',
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: 'Type Results Category',
  about: 'As presented in the proposed programme budget for 2027',
  aboutUs1: 'Welcome to the ',
  aboutUs2: 'Budget Result Dashboard',
  aboutUs3:
    ' — a joint collaboration between The Office of Programme Planning and Finance Budget (OPPFB) and the Office of Information and Communications Technology (OICT).',
  aboutUs4:
    'The dashboard provides a summarized display of extracts from the proposed programme budget for 2027 in an easy and user-friendly manner.',
  aboutUs5: '',
  aboutUs6: 'Users can group the information by section, entity, subprogramme, country or category of result.',
  aboutUsTitle: 'About this site',
};

export const PromptsCHN = {
  title: '预算结果看板',
  filter1: '广泛结果',
  filter4: '具体结果',
  filter2: '预算分款',
  filter3: '次级方案',
  filterBeneficiary: '受益人', //'Beneficiary',
  filterPriority: '优先事项', //'Priority',
  placeholder1: '选择广泛结果',
  placeholder4: '选择具体结果',
  placeholder2: '选择预算分款',
  placeholder3: '选择次级方案',
  resultsCount: '个结果',
  source: '来源: ',
  budgetSection: '预算分款 ',
  subprogramme: '次级项目',
  appliedFilters: '筛选',
  memberState: '成员国',
  budgetSectionFirst: '请先选择预算分款',
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: '在此输入结果分类',
  // about:"如2021年方案概算中所述",
  about: '如2027年拟议方案预算所示',
  aboutUs1: '欢迎来到',
  aboutUs2: '预算结果看板',
  aboutUs3: ' - 方案规划和财政预算办公室（OPPFB）与信息和通信技术办公室（OICT）之间的联合合作.',
  aboutUs4: '结果看板以简单和用户友好的方式摘要显示了2027年拟议计划预算的摘要。',
  aboutUs5: '',
  aboutUs6: '用户可以按部门，实体，子计划，国家或结果类别对信息进行分组。',
  aboutUsTitle: '关于本网站',
};

export const PromptsFRE = {
  title: 'Tableau de bord des résultats',
  filter1: 'Résultat global',
  filter4: 'Résultat',
  filter2: 'Chapitre du budget',
  filter3: 'Sous-programme',
  filterBeneficiary: 'Bénéficiaire', //'Beneficiary',
  filterPriority: 'Priorité', //'Priority',
  placeholder1: 'Sélectionnez un résultat global',
  placeholder4: 'Sélectionnez un résultat',
  placeholder2: 'Sélectionnez un chapitre du budget',
  placeholder3: 'Sélectionnez un sous-programme',
  resultsCount: ' résultat(s) affiché(s)',
  source: 'Source : ',
  budgetSection: 'Chapitre ',
  subprogramme: 'Sous-programme',
  appliedFilters: 'Filtres',
  memberState: 'Etat membre',
  budgetSectionFirst: "Assurez-vous de sélectionner d'abord une section de budget",
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: 'Sélectionnez un résultat',
  // about:"Tel que présenté dans le projet de budget programme pour 2021",
  about: 'D’après le projet de budget-programme pour 2027',
  aboutUs1: 'Bienvenue à la ',
  aboutUs2: 'Tableau de bord des résultats',
  aboutUs3:
    " - une collaboration conjointe entre le Bureau de la planification des programmes et du budget financier (OPPFB) et le Bureau des technologies de l'information et de la communication (OICT).",
  aboutUs4: "Le tableau de bord présente un résumé d'extraits du projet de budget programme pour 2027 d'une manière simple et conviviale.",
  aboutUs5: '',
  aboutUs6: 'Les utilisateurs peuvent regrouper les informations par section, entité, sous-programme, pays ou catégorie de résultat.',
  aboutUsTitle: 'À propos de ce site',
};

export const PromptsESP = {
  title: 'Panel de resultados del presupuesto',
  filter1: 'Resultado amplio',
  filter4: 'Resultado específico',
  filter2: 'Sección del presupuesto',
  filter3: 'Subprograma',
  filterBeneficiary: 'Beneficiario', //'Beneficiary',
  filterPriority: 'Prioridad', //'Priority',
  placeholder1: 'Seleccionar resultado amplio',
  placeholder4: 'Select Specific Result',
  placeholder2: 'Elegir sección del presupuesto',
  placeholder3: 'Elegir subprograma',
  resultsCount: ' Resultados mostrados',
  source: 'Fuente: ',
  budgetSection: 'Sección del presupuesto ',
  subprogramme: 'Subprograma',
  appliedFilters: 'Filtros',
  memberState: 'Estado miembro',
  budgetSectionFirst: 'Asegúrese de seleccionar primero una sección de presupuesto',
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: 'Tipo de categoría de resultados',
  // about:"Como se presenta en el proyecto de presupuesto por programas para 2021",
  about: 'Conforme se presenta en el proyecto de presupuesto por programas para 2027',
  aboutUs1: 'Bienvenida a la ',
  aboutUs2: 'Panel de resultados del presupuesto',
  aboutUs3:
    ' - una colaboración conjunta entre la Oficina de Planificación de Programas y Presupuesto Financiero (OPPFB) y la Oficina de Tecnología de la Información y las Comunicaciones (OICT).',
  aboutUs4:
    'El tablero proporciona una visualización resumida de extractos del presupuesto del programa propuesto para 2027 de una manera fácil y fácil de usar.',
  aboutUs5: '',
  aboutUs6: 'Los usuarios pueden agrupar la información por sección, entidad, subprograma, país o categoría de resultado.',
  aboutUsTitle: 'Acerca de este sitio',
};

export const PromptsRUS = {
  title: 'Панель результатов предусмотренной в бюджете деятельности',
  filter1: 'Широкий результат',
  filter4: 'Конкретный результат',
  filter2: 'Раздел бюджета',
  filter3: 'Подпрограмма',
  filterBeneficiary: 'Бенефициар', //'Beneficiary',
  filterPriority: 'Приоритет', //'Priority',
  placeholder1: 'Выберите широкий результат',
  placeholder4: 'Выберите конкретный результат',
  placeholder2: 'Выберите раздел бюджета',
  placeholder3: 'Выберите подпрограмму',
  resultsCount: ' показанных результатов',
  source: 'Источник: ',
  budgetSection: 'Раздел бюджета ',
  subprogramme: 'Подпрограмма',
  appliedFilters: 'Фильтры',
  memberState: 'Государство-член',
  budgetSectionFirst: 'Обязательно сначала выберите раздел бюджета',
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: 'Введите категорию результатов',
  // about:"Как представлено в предлагаемом программном бюджете на 2021 г.",
  about: 'Согласно предлагаемому бюджету по программам на 2027 год',
  aboutUs1: 'Добро пожаловать в ',
  aboutUs2: 'Панель результатов предусмотренной в бюджете деятельности',
  aboutUs3:
    ' - совместное сотрудничество между Управлением планирования программ и финансового бюджета (OPPFB) и Управлением информационно-коммуникационных технологий (OICT).',
  aboutUs4:
    'На информационной панели в простой и удобной форме представлена ​​сводная информация о выдержках из предлагаемого программного бюджета на 2027 год.',
  aboutUs5: '',
  aboutUs6: 'Пользователи могут группировать информацию по разделам, объектам, подпрограммам, странам или категориям результатов.',
  aboutUsTitle: 'Об этом сайте',
};

export const PromptsARB = {
  title: 'لوحة نتائج الميزانية',
  filter1: 'نتيجة واسعة',
  filter4: 'نتيجة محددة',
  filter2: 'باب الميزانية',
  filter3: 'البرنامج الفرعي',
  filterBeneficiary: 'الجهة المستفيدة', //'Beneficiary',
  filterPriority: 'الأولوية', //'Priority',
  placeholder1: 'حدد نتيجة تقريبية',
  placeholder4: 'حدد نتيجة محددة',
  placeholder2: 'حدد باب الميزانية',
  placeholder3: 'حدد البرنامج الفرعي',
  resultsCount: ' النتيجة (النتائج) المعروضة',
  source: 'المصدر: ',
  budgetSection: 'باب الميزانية ',
  subprogramme: 'البرنامج الفرعي',
  appliedFilters: 'المرشحات',
  memberState: 'دولة عضو',
  budgetSectionFirst: 'يرجى التأكد من تحديد قسم الميزانية أولاً',
  partitionSymbol: '. ',
  partitionSymbol2: ' : ',
  resultsCategoryHint: 'اكتب فئة النتائج',
  // about:"كما هو معروض في الميزانية البرنامجية المقترحة لعام 2021",
  about:"كما هو معروض في الميزانية البرنامجية المقترحة لعام 2027",
  aboutUs1: 'أهلا بك في ',
  aboutUs2: 'لوحة نتائج الميزانية',
  aboutUs3: ' - تعاون مشترك بين مكتب تخطيط البرامج والميزانية المالية (OPPFB) ومكتب تكنولوجيا المعلومات والاتصالات (OICT).',
  aboutUs4: 'توفر لوحة القيادة عرضًا موجزًا ​​لمقتطفات من الميزانية البرنامجية المقترحة لعام2027 بطريقة سهلة وسهلة الاستخدام.',
  aboutUs5: '',
  aboutUs6: 'يمكن للمستخدمين تجميع المعلومات حسب القسم أو الكيان أو البرنامج الفرعي أو البلد أو فئة النتيجة.',
  aboutUs:
    'مرحبًا بكم في "لوحة نتائج الميزانية"، وهو تعاون مشترك بين مكتب تخطيط البرامج والميزانية المالية ومكتب تكنولوجيا المعلومات والاتصالات ستمكنك لوحة المعلومات من عرض قصص النتائج الموجزة والمصنفة بطريقة بسيطة وسهلة الهضم. يتم تجميع قصص نتائج الميزانية حسب، ويمكن تصفيتها حسب برامج الميزانية والبرامج الفرعية والكيانات المعنية',
  aboutUsTitle: 'حول هذا الموقع',
};
